import { PUBLIC_ESTATE_FILTERS } from '../constants';
import { GET } from '../api';

import type { GetStrapiCountriesResponse } from '../types';

import type { Locales, StrapiCountry } from '@monoimin/sb-types';

export async function getStrapiCountries({
  pagination,
  locale = 'en',
  filters = {},
  isDraft,
}: {
  locale?: Locales;
  pagination?: { page: number; pageSize: number };
  filters?: Record<string, any>;
  isDraft?: boolean;
} = {}): Promise<GetStrapiCountriesResponse> {
  const estateFilters = isDraft ? {} : PUBLIC_ESTATE_FILTERS;

  const { data } = await GET(`/countries`, {
    params: {
      query: {
        'pagination[page]': pagination?.page,
        'pagination[pageSize]': pagination?.pageSize,
        fields: ['slug', 'is_eu', 'code', 'publishedAt'],
        populate: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-expect-error
          estates: {
            count: true,
            filters: {
              ...PUBLIC_ESTATE_FILTERS,
              locale: {
                $eq: locale,
              },
            },
          },
        },
        publicationState: 'live',
        filters: {
          estates: estateFilters,
          ...filters,
        },
        sort: 'slug:asc',
        locale: locale,
      },
    },
  });

  return {
    countries: (data?.data ?? []) as StrapiCountry[],
    totalCount: data?.meta?.pagination?.total ?? 0,
    pageCount: data?.meta?.pagination?.pageCount ?? 0,
  };
}

export default getStrapiCountries;
